import request from "@/router/axios";

export const exportUserData = (params) => {
  return request({
    url: "/api/jida-user/export-user",
    method: "get",
    responseType: "blob",
    headers: { "Content-Type": "application/json" },
    params: {
      ...params,
    },
  });
};

export const getList = (current, size, params, deptId) => {
  return request({
    url: "/api/jida-user/page",
    method: "get",
    params: {
      ...params,
      current,
      size,
      deptId,
    },
  });
};

export const searchList = (params) => {
  return request({
    url: "/api/jida-user/page",
    method: "get",
    params: params,
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/jida-user/remove",
    method: "post",
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: "/api/jida-user/submit",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/jida-user/update",
    method: "post",
    data: row,
  });
};

export const updatePlatform = (userId, userType, userExt) => {
  return request({
    url: "/api/jida-user/update-platform",
    method: "post",
    params: {
      userId,
      userType,
      userExt,
    },
  });
};

export const getUser = (id) => {
  return request({
    url: "/api/jida-user/detail",
    method: "get",
    params: {
      id,
    },
  });
};

export const getUserPlatform = (id) => {
  return request({
    url: "/api/jida-user/platform-detail",
    method: "get",
    params: {
      id,
    },
  });
};

export const getUserInfo = () => {
  return request({
    url: "/api/jida-user/info",
    method: "get",
  });
};

export const resetPassword = (userIds) => {
  return request({
    url: "/api/jida-user/reset-password",
    method: "post",
    params: {
      userIds,
    },
  });
};
export const addQGKHKUserAndAuth = (params) => {
  console.log(params);
  return request({
    url: "/api/park-company/companycheckin/addQGKHKUserAndAuth",
    method: "get",
    params: params,
  });
};
/** 临时开放闸机权限1天 */
export const addTempUserDoor = (params) => {
  console.log(params);
  return request({
    url: "/api/park-company/companycheckin/addOneDayQGKHKUserAndAuth",
    method: "get",
    params: params,
  });
};

export const updatePassword = (oldPassword, newPassword, newPassword1) => {
  return request({
    url: "/api/jida-user/update-password",
    method: "post",
    params: {
      oldPassword,
      newPassword,
      newPassword1,
    },
  });
};

export const updateInfo = (row) => {
  return request({
    url: "/api/jida-user/update-info",
    method: "post",
    data: row,
  });
};

export const grant = (userIds, roleIds) => {
  return request({
    url: "/api/jida-user/grant",
    method: "post",
    params: {
      userIds,
      roleIds,
    },
  });
};
